export enum REQUEST_TYPES {
	GET_SYSTEM_NOTIFICATIONS = 'GET_SYSTEM_NOTIFICATIONS',
	UPDATE_SET_AS_SHOW_NOTIFY = 'UPDATE_SET_AS_SHOW_NOTIFY'
}